document.addEventListener('DOMContentLoaded', function () {
    console.log("Distex Popup Engine v80 - Final Polish");

    var overlay = document.getElementById('custom-popup-overlay');
    // We target the CONTAINER of the form to wipe it clean
    var column = document.querySelector('.custom-popup-form-column');
    var settings = window.popupSettings || { delay: 3, exitIntent: true };

    // v80 for fresh icon/color test
    var STORAGE_KEY = 'distex_final_v80';

    if (localStorage.getItem(STORAGE_KEY)) return;

    // --- NUCLEAR DOM REPLACEMENT ---
    function nuclearDomSwap() {
        if (!column) return;

        if (document.getElementById('custom-popup-form-v80')) return;

        // 1. Harvest existing text
        var oldTitle = "FREE SHIPPING!";
        var sub_el = column.querySelector('.custom-popup-subtitle');
        var oldSubtitle = sub_el ? sub_el.textContent : "Unlock free shipping on your first order when you sign up by email.";

        // 2. WIPE THE COLUMN
        column.innerHTML = '';

        // 3. BUILD NEW STRUCTURE
        // Main Content Container
        var mainDiv = document.createElement('div');
        mainDiv.id = 'custom-popup-main-content-v80';
        mainDiv.style.width = '100%';
        mainDiv.style.display = 'block';

        var h2 = document.createElement('h2');
        h2.className = 'js-title';
        h2.textContent = oldTitle;

        var pSub = document.createElement('p');
        pSub.className = 'js-subtitle';
        pSub.textContent = oldSubtitle;

        // Form
        var form = document.createElement('form');
        form.id = 'custom-popup-form-v80';
        form.style.marginTop = '15px';
        form.style.display = 'block';

        var inputDiv = document.createElement('div');
        inputDiv.className = 'form-group';
        var input = document.createElement('input');
        input.type = 'email';
        input.id = 'custom-popup-email-v80';
        input.placeholder = 'Email Address';
        input.required = true;
        input.className = 'custom-popup-input'; // Use existing CSS class
        inputDiv.appendChild(input);

        var btn = document.createElement('button');
        btn.type = 'submit';
        btn.textContent = 'GET FREE SHIPPING';
        btn.className = 'custom-popup-submit'; // Use existing CSS class

        // Terms (HTML)
        var terms = document.createElement('p');
        terms.className = 'js-terms';
        terms.style.color = '#6B7280'; // Forced color
        terms.innerHTML = 'By signing up you agree to receive email marketing. Unsubscribe at any time. Free shipping on orders over £30.';

        form.appendChild(inputDiv);
        form.appendChild(btn);
        form.appendChild(terms);

        mainDiv.appendChild(h2);
        mainDiv.appendChild(pSub);
        mainDiv.appendChild(form);

        // Success Container (Hidden by default)
        var successDiv = document.createElement('div');
        successDiv.id = 'custom-popup-success-v80';
        successDiv.style.display = 'none'; // Hidden
        successDiv.style.textAlign = 'center';
        successDiv.style.padding = '40px 0';
        successDiv.style.flexDirection = 'column';
        successDiv.style.alignItems = 'center';

        // SF Symbol Style Envelope Icon (SVG) - Blue
        var iconSvg = `
        <div style="margin-bottom: 25px; display: flex; justify-content: center;">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#5ABBF1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2"/>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
            </svg>
        </div>
        `;

        successDiv.innerHTML = iconSvg + `
            <div id="msg-new-v60">
                <h3 style="font-size: 1.5rem; margin-bottom: 10px; color: #111827;">Check your inbox!</h3>
                <p style="color: #4B5563;">Your unique discount code is on its way. Please check your email to claim your free shipping!</p>
            </div>
            <div id="msg-old-v60" style="display:none;">
                <h3 style="font-size: 1.5rem; margin-bottom: 10px; color: #5ABBF1;">Welcome Back!</h3>
                <p style="color: #4B5563;">You're already on our list. We've sent your code via email previously—check your inbox!</p>
            </div>
            <a href="https://www.distex.co.uk" style="display: inline-block; width: 100%; padding: 16px; background: #111827; color: white; text-decoration: none; border-radius: 8px; font-weight: 700; margin-top: 20px;">SHOP THE COLLECTION</a>
        `;

        // INJECT BOTH into the column
        column.appendChild(mainDiv);
        column.appendChild(successDiv);

        bindSubmit(form, btn, input, mainDiv, successDiv);
    }

    function bindSubmit(form, btn, emailInput, mainDiv, successDiv) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            var originalText = btn.textContent;
            btn.textContent = 'SUBMITTING...';
            btn.disabled = true;
            btn.style.opacity = '0.7';

            var emailValue = emailInput.value;
            if (!emailValue || !emailValue.includes('@')) {
                btn.textContent = 'INVALID EMAIL';
                setTimeout(function () {
                    btn.textContent = originalText;
                    btn.disabled = false;
                    btn.style.opacity = '1';
                }, 2000);
                return;
            }

            var controller = new AbortController();
            var timeoutId = setTimeout(function () { controller.abort(); }, 15000);

            fetch('https://qqvtgddplmkewjkcbtgz.supabase.co/functions/v1/subscribe-user', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: emailValue,
                    page_url: window.location.href,
                    source: 'popup'
                }),
                signal: controller.signal
            })
                .then(function (response) {
                    clearTimeout(timeoutId);
                    if (!response.ok) {
                        return response.json().then(function (err) { throw err; })
                            .catch(function () { throw new Error('Status: ' + response.status); });
                    }
                    return response.json();
                })
                .then(function (data) {
                    mainDiv.style.display = 'none';
                    successDiv.style.display = 'block';

                    var newMsg = document.getElementById('msg-new-v60');
                    var oldMsg = document.getElementById('msg-old-v60');

                    if (data.alreadySubscribed) {
                        newMsg.style.display = 'none';
                        oldMsg.style.display = 'block';
                    } else {
                        newMsg.style.display = 'block';
                        oldMsg.style.display = 'none';
                    }
                })
                .catch(function (err) {
                    clearTimeout(timeoutId);
                    console.error("Popup Error:", err);
                    var msg = 'Error. Retry.';
                    if (err.name === 'AbortError') msg = 'Timeout. Retry.';
                    else if (err.error) msg = err.error || 'Error';
                    else if (err.message) msg = err.message;

                    btn.textContent = msg.toUpperCase().substring(0, 30);
                    setTimeout(function () {
                        btn.textContent = originalText;
                        btn.disabled = false;
                        btn.style.opacity = '1';
                    }, 4000);
                });
        });
    }

    function show() {
        if (localStorage.getItem(STORAGE_KEY)) return;
        if (overlay) {
            nuclearDomSwap();
            overlay.classList.add('visible');
            overlay.classList.remove('hidden');
            localStorage.setItem(STORAGE_KEY, 'true');
        }
    }

    if (settings.delay >= 0) {
        setTimeout(show, settings.delay * 1000);
    }

    if (settings.exitIntent) {
        document.addEventListener('mouseleave', function (e) {
            if (e.clientY <= 0) show();
        });
    }

    var closeBtn = document.getElementById('custom-popup-close');
    if (closeBtn) {
        closeBtn.onclick = function () {
            if (overlay) overlay.classList.remove('visible');
        };
    }
});
